@import "tailwindcss";
@import "uniwind";

@theme {
  --breakpoint-xs: 320px;
  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
  --breakpoint-2xl: 1536px;

  --radius: 0.2rem;
  --max-width-content: 1200px;
  --max-width-content-wide: 1400px;
  --max-width-reading: 65ch;

  --spacing-safe: env(safe-area-inset-top);
  --spacing-safe-offset-4: calc(env(safe-area-inset-bottom) + 1rem);
  --spacing-safe-bottom: env(safe-area-inset-bottom);
}

@layer base {
  html {
    height: -webkit-fill-available;
  }

  body {
    height: -webkit-fill-available;
  }

  #root {
    height: -webkit-fill-available;
  }
}
